import { render, staticRenderFns } from "./GlobalSearch.vue?vue&type=template&id=1f0645da&scoped=true"
import script from "./GlobalSearch.vue?vue&type=script&lang=js"
export * from "./GlobalSearch.vue?vue&type=script&lang=js"
import style0 from "./GlobalSearch.vue?vue&type=style&index=0&id=1f0645da&prod&lang=css"
import style1 from "./GlobalSearch.vue?vue&type=style&index=1&id=1f0645da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0645da",
  null
  
)

export default component.exports